<template>
    <a-config-provider :locale="zhCN">
        <RouterView />
    </a-config-provider>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { genUuid } from '@/utils/index'
import { accountApi } from '@/api/account'
import { useUserInfoStore } from '@/stores/user-info'

sessionStorage.setItem('session_id', genUuid())
const point = (page_type, point_type, params, trigger) => {
    const userStore = useUserInfoStore()
    let user_id = userStore?.userInfo?.id
    let mobile = userStore?.userInfo?.mobile
    let session_id = sessionStorage.getItem('session_id')
    accountApi.report({
        user_id: user_id || '',
        mobile: mobile || '',
        client_type: 1,
        page_type,
        point_type,
        params: params || '',
        session_id,
        trigger: trigger || ''
    })
}
window.point = point
</script>
